import { useWarehousesRegistry } from './useWarehousesRegistry';
import { useWarehousesRegistryEffects } from './useWarehousesRegistryEffects';

export { useWarehousesRegistry, useWarehousesRegistryEffects };
